<div class="page">
    <div class="page-head">
        <div>
            <h2>{{ pageTitle() }}</h2>
            <p>Configure number series, their type, separator and reset cycle.</p>
        </div>
        <p-button label="Add Series" icon="pi pi-plus" (onClick)="openAdd()" />
    </div>

    <div class="card">
        <p-table [value]="masters()" [loading]="loading()" dataKey="id" [rows]="10"
            [paginator]="masters().length > 10" [rowsPerPageOptions]="[10, 25, 50]" styleClass="p-datatable-sm"
            [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first}–{last} of {totalRecords}">
            <ng-template pTemplate="header">
                <tr>
                    <th>Series Name</th>
                    <th>Type</th>
                    <th>Separator</th>
                    <th>Reset</th>
                    <th class="ta-r" style="width: 110px">Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-m>
                <tr>
                    <td class="strong">{{ m.seriesName }}</td>
                    <td>{{ typeNameById(m.seriesTypeID) }}</td>
                    <td class="mono">{{ m.separator || '—' }}</td>
                    <td>
                        @if (m.resetType && m.resetType !== 'None') {
                            <p-tag [value]="m.resetType" severity="info" />
                        } @else {
                            <span class="muted">None</span>
                        }
                    </td>
                    <td class="ta-r">
                        <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" severity="secondary"
                            pTooltip="Edit" (onClick)="openEdit(m)" />
                        <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger"
                            pTooltip="Delete" (onClick)="remove(m)" />
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="5">
                        <div class="state"><i class="pi pi-inbox"></i><p>No series defined yet. Click <strong>Add Series</strong> to create one.</p></div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<!-- ===================== ADD / EDIT MODAL ===================== -->
<p-dialog [visible]="showModal()" (visibleChange)="showModal.set($event)" [modal]="true"
    [draggable]="true" [resizable]="false" [closable]="true" [dismissableMask]="false"
    [header]="editing() ? 'Edit Series' : 'Add Series'" styleClass="menu-dialog"
    [style]="{ width: '480px' }" [breakpoints]="{ '480px': '94vw' }">
    <form [formGroup]="form" class="menu-form">
        <div class="field">
            <label>Series Name <span class="req">*</span></label>
            <input type="text" pInputText formControlName="seriesName" placeholder="e.g. Invoice 2026">
            @if (form.get('seriesName')?.touched && form.get('seriesName')?.invalid) {
                <small class="err">Required</small>
            }
        </div>

        <div class="field">
            <label>Series Type <span class="req">*</span></label>
            <p-select formControlName="seriesTypeID" [options]="types()" optionLabel="label" optionValue="value" [filter]="true" filterBy="label" placeholder="Select a type..." appendTo="body" />
            @if (!types().length) {
                <small class="hint">No series types found — create one in <b>Series Types</b> first.</small>
            }
            @if (form.get('seriesTypeID')?.touched && form.get('seriesTypeID')?.invalid) {
                <small class="err">Required</small>
            }
        </div>

        <div class="grid-2">
            <div class="field">
                <label>Separator</label>
                <input type="text" pInputText formControlName="separator" placeholder="- / /">
            </div>
            <div class="field">
                <label>Reset Type</label>
                <p-select formControlName="resetType" [options]="resetTypes" placeholder="Select reset type" appendTo="body" />
            </div>
        </div>

        <div class="modal-actions">
            <p-button label="Cancel" [outlined]="true" (onClick)="closeModal()" />
            <p-button [label]="saving() ? 'Saving...' : 'Save'"
                [icon]="saving() ? 'pi pi-spin pi-spinner' : ''" (onClick)="save()" [loading]="saving()" />
        </div>
    </form>
</p-dialog>
